import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="network-search"
export default class extends Controller {
  static targets = ["teaser", "expanded"];

  show() {
    if (this.teaserTarget && this.expandedTarget) {
      this.teaserTarget.style.display = "none";
      this.expandedTarget.style.display = "block";
    }
  }

  hide() {
    if (this.teaserTarget && this.expandedTarget) {
      this.teaserTarget.style.display = "block";
      this.expandedTarget.style.display = "none";
    }
  }
}
